import React from "react";

export default function MySQL_INSTR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_INSTR</h1>
      <p>This is the MySQL_INSTR component generated from the SQL JSON.</p>
    </div>
  );
}
